import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import About from "@/components/About";
import Statistics from "@/components/Statistics";
import Services from "@/components/Services";
import Industries from "@/components/Industries";
import Process from "@/components/Process";
import WhyChoose from "@/components/WhyChoose";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";

function Loader() {
  return (
    <div className="jo-loader" data-testid="page-loader">
      <div className="flex flex-col items-center">
        <div className="h-16 w-16 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center mb-6">
          <span className="text-white font-extrabold text-3xl">J</span>
        </div>
        <div className="h-0.5 w-40 bg-white/20 rounded-full overflow-hidden">
          <div className="jo-loader-bar" />
        </div>
        <span className="mt-4 text-white/60 text-xs tracking-[0.3em] uppercase">
          Johar Softech
        </span>
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <Loader />
      <Toaster position="top-center" richColors closeButton />
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Statistics />
        <Services />
        <Industries />
        <Process />
        <WhyChoose />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
